<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">预警配置</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="预警类型">
            <el-select v-model="AlarmType" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in AlarmTypeArr"
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.Extend1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="AlertName"
                label="预警类型"
              ></el-table-column>
              <el-table-column
                prop="ServiceMonitorObjectName"
                label="监测对象"
              ></el-table-column>
              <el-table-column
                prop="ServiceHttpType"
                label="请求方式"
              ></el-table-column>
              <el-table-column
                prop="ServiceInvokeUrl"
                label="接口地址"
                width="140"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    title="接口地址"
                    width="250"
                    trigger="hover"
                  >
                    <div>{{ scope.row.ServiceInvokeUrl }}</div>
                    <span slot="reference">{{
                      scope.row.ServiceInvokeUrl != null &&
                      scope.row.ServiceInvokeUrl.length > 15
                        ? scope.row.ServiceInvokeUrl.substr(0, 15) + "..."
                        : scope.row.ServiceInvokeUrl
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="EarlyWarningEnabled" label="预警开启">
                <template slot-scope="scope">
                  <span v-if="scope.row.EarlyWarningEnabled == '0'">否</span>
                  <span v-else-if="scope.row.EarlyWarningEnabled == '1'"
                    >是</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="EarlyWarningValue"
                label="预警阈值"
              ></el-table-column>
              <el-table-column prop="AlarmEnabled" label="报警开启">
                <template slot-scope="scope">
                  <span v-if="scope.row.EarlyWarningEnabled == '0'">否</span>
                  <span v-else-if="scope.row.EarlyWarningEnabled == '1'"
                    >是</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="AlarmValue"
                label="报警阈值"
              ></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "ServiceConfigAdminList",
  controller: "UI",
  action: "ServiceConfigAdminList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      AlarmType: "",
      AlarmTypeArr: [],
    };
  },
  created: function() {
    //预警类型
    this.getAlarmType();
    //TODO 获取用户按钮权限
    //this.getMenus();
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "预警设置-管理员查询";
    this.logInfo.LogMessage = "预警设置-管理员查询";
    this.logInfo.ModuleName = "预警设置";
    this.logInfo.PageName = "预警设置-管理员列表";
    this.addOperationLog();
  },
  filters: {
    formatDatSingle(data) {
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
  methods: {
    getAlarmType() {
      //预警类型
      this.config
        .getUValue("AlarmSubsystem:AlarmType", "")
        .then((d) => {
          this.AlarmTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    search() {
      let searchInfo = {
        AlertType: this.AlarmType,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.TranResourcesApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.$message({
                  type: "error",
                  message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
                });
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/dataDetection/UI/ServiceConfigAdminEdit",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/dataDetection/ui/ServiceConfigAdminEdit",
        query: { InfoId: row.Id, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/dataDetection/ui/ServiceConfigAdminEdit",
        query: { InfoId: row.Id, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.TranResourcesApi()
            .DelItem(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.logInfo.ActionName = "预警信息删除";
                this.logInfo.LogMessage = "预警信息删除成功";
                this.logInfo.ModuleName = "预警设置";
                this.logInfo.PageName = "预警设置-管理员列表";
                this.logInfo.PreValue = JSON.stringify(row);
                this.addOperationLog();
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.AlarmType = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>
